import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';

import { Swiper, SwiperSlide } from 'swiper/react';

import ArrowButton from '../Shared/ArrowButton';
import { BREAKPOINTS, COLORS } from '../../styles/variables';
import { ButtonLink } from '../../styles/textTags';
import { BASE_URL } from '../../features/queries/config';

import 'swiper/css';

const Slider = ({ data }) => {
  console.log('slider',data.Slider.data);
  const sliderData = data.Slider.data;
  const logoLink = data.Museum_link || '';
  const logoImg = data.Museum_logo.data.attributes.url || '';
  const ticketLink = data.Buy_ticket || '';

  const swiperRef = useRef(null);

  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const toggleFullscreen = (imageUrl) => {
    setFullscreenImage(fullscreenImage === imageUrl ? null : imageUrl);
  };

  return (
    <SliderWr>
      {logoLink ? (
        <SliderLink href={logoLink} target='_blank'>
          <SliderLogo src={BASE_URL + logoImg} />
        </SliderLink>
      ) : (
        <DisabledLink>
          <SliderLogo src={BASE_URL + logoImg} />
        </DisabledLink>
      )}

      <ArrowButton backDirection className='prev' onClick={handlePrev} />

      <SwiperStyled ref={swiperRef} slidesPerView={1} spaceBetween={30} speed={1000} loop={true}>
        {sliderData?.map((image, index) => (
          <SwiperSlideStyled key={index} onClick={() => toggleFullscreen(BASE_URL + image.attributes.url )}>
            <SlideImage
              src={BASE_URL + image.attributes.url}
              alt={`Изображение ${index}`}

            />
          </SwiperSlideStyled>
        ))}
      </SwiperStyled>
      <ArrowButton className='next' onClick={handleNext} />
      {ticketLink && (
        <BottomLinkBtn href={ticketLink} target='_blank'>
          Купить билет
        </BottomLinkBtn>
      )}

      {fullscreenImage && (
        <FullscreenOverlay onClick={() => setFullscreenImage(null)}>
          <FullscreenImage src={fullscreenImage} alt="" />
        </FullscreenOverlay>
      )}
    </SliderWr>
  );
};

const SliderWr = styled.div`
  margin-bottom: 50px;
  position: relative;
  display: flex;
  align-items: center;
  height: 38.06vw;

  .next,
  .prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.8);
    border: none;
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 200;

    &.prev {
      left: 40px;
      @media ${BREAKPOINTS.laptop} {
        left: 2.78vw;
      }
      @media ${BREAKPOINTS.mobile} {
        left: 3.33vw;
      }
    }

    &.next {
      right: 40px;
      @media ${BREAKPOINTS.laptop} {
        right: 2.78vw;
      }
      @media ${BREAKPOINTS.mobile} {
        right: 3.33vw;
      }
    }
  }

  @media ${BREAKPOINTS.laptop} {
    margin-bottom: 3.47vw;
    height: 38.06vw;
  }
  @media ${BREAKPOINTS.mobile} {
    margin-bottom: 5.83vw;
    height: 100vw;
  }
`;

const SwiperStyled = styled(Swiper)`
  width: 100%;
  height: 100%;
  /* max-width: 1200px; */
  overflow: hidden;
  border-radius: 28px;
  @media ${BREAKPOINTS.laptop} {
    border-radius: 1.94vw;
  }
  @media ${BREAKPOINTS.mobile} {
    border-radius: 5.83vw;
  }
`;

const SwiperSlideStyled = styled(SwiperSlide)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  height: 100%;
  position: relative;
  transition: 0.2s;
  &:hover {    
    transform: scale(1.05);
  }
`;

const SlideImage = styled.img`
  height: 100%;
  width: 100%;
  border-radius: 28px;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
  
  @media ${BREAKPOINTS.laptop} {
    border-radius: 1.94vw;
  }
  @media ${BREAKPOINTS.mobile} {
    border-radius: 5.83vw;
  }
`;

const FullscreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const FullscreenImage = styled.img`
  max-width: 90%;
  max-height: 90%;
`;

const BottomLinkBtn = styled(ButtonLink)`
  position: absolute;
  bottom: 40px;
  right: 40px;
  color: ${COLORS.white};
  z-index: 100;
  @media ${BREAKPOINTS.laptop} {
    bottom: 2.78vw;
    right: 2.78vw;
  }
  @media ${BREAKPOINTS.mobile} {
    bottom: 4.17vw;
    right: 4.17vw;
  }
`;

const linkStyles = css`
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 101;
  width: 182px;
  height: 160px;
  object-fit: contain;
  border-radius: 0 28px 0 60px;
  background-color: ${COLORS.white};
  padding: 40px 20px;

  @media ${BREAKPOINTS.laptop} {
    width: 12.64vw;
    height: 11.11vw;
    padding: 2.78vw 1.39vw;
    border-radius: 0 1.94vw 0 4.17vw;
  }
  @media ${BREAKPOINTS.mobile} {
    width: 24.38vw;
    height: 20.83vw;
    padding: 6.67vw 3.33vw;
    border-radius: 0 5.83vw 0 10.42vw;
  }
`;

const SliderLink = styled.a`
  cursor: pointer;
  ${linkStyles}
`;

const DisabledLink = styled.div`
  ${linkStyles}
`;

const SliderLogo = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

export default Slider;
